/**
 * Created by contrapro on 2018/5/26
 */


import { ACTION_TYPE_SCAN_RESULT } from '../actions';

const initialState = {
    currentWorkName:'',
};

export default function workReducer(state = initialState, action) {
    switch (action.type) {

        case ACTION_TYPE_SCAN_RESULT:
            console.log(ACTION_TYPE_SCAN_RESULT, action.payload.filename);
            return {
                ...state,
                // wishes:action.payload.res
                currentWorkName:action.payload.filename
            };



        default:
            return { ...state };
    }
}



// WEBPACK FOOTER //
// ./src/reducers/work.js